import { render, staticRenderFns } from "./TradersSidebar.vue?vue&type=template&id=515eddc1&"
import script from "./TradersSidebar.vue?vue&type=script&lang=js&"
export * from "./TradersSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports